export const sanitizeForUrl = (str) => {
    if (!str) return '';
    const trimmedStr = String(str).trim();
    return encodeURIComponent(
        trimmedStr.replace(/%/g, '')
            .replace(/[>]/g, '')
            .replace(/\//g, '_')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim()
    );
};

export const buildPdpUrl = (itemDesc = '', usfitem = '') => {
    let ses = String(itemDesc).trim().replace(/\s+/g, '-');
    ses = ses.toLowerCase().replace(/[^0-9a-zA-Z-]/g, '');
    ses = ses.replace(/-+/g, '-');
    ses = ses.replace(/-+$/, '');
    ses = ses.replace(/^-+/, '');

    const reservedWords = ['and', 'or'];
    let words = ses.split('-');
    words = words.filter((word) => !reservedWords.includes(word));
    ses = words.join('-');

    return `/p/${ses}_${usfitem}/`;
};

export default {
    sanitizeForUrl,
    buildPdpUrl,
};